const getFileType = (FileExt, defaultValue = 'another', onlyExt = true) => {
  if (!FileExt) return FileExt;

  if (onlyExt && FileExt.includes('.')) {
    FileExt = FileExt.slice(FileExt.lastIndexOf('.') + 1);
  }

  switch (true) {
    case /jpg|png|jpeg|gif|bmp|tiff|svg|image/i.test(FileExt):
      return 'image';

    case /doc|word/i.test(FileExt):
      return 'word';

    case /xls|sheet/i.test(FileExt):
      return 'sheet';

    case /ppt|presentation/i.test(FileExt):
      return 'presentation';

    case /zip|rar|compressed/i.test(FileExt):
      return 'compressed';

    case /pdf/i.test(FileExt):
      return 'pdf';

    default:
      return defaultValue;
  }
};

export default getFileType;